<template>
  <el-main>
    <div class="total">
      <div class="item">
        <p>{{ amount_sum }}</p>
        <p>员工总积分</p>
      </div>
      <div class="item">
        <p>{{ cash_sum }}</p>
        <p>现有积分</p>
      </div>
      <div class="item">
        <p>{{ apply_sum }}</p>
        <p>已扣除积分</p>
      </div>
      <div class="item">
        <p>{{ frozen_sum }}</p>
        <p>待入账积分</p>
      </div>
    </div>
    <el-form class="el-form-search" label-width="100px">
      <el-form-item label="用户昵称：">
        <el-input v-model="keywords_type.nickname" size="small" @input="getKeywords($event, 1)"></el-input>
      </el-form-item>
      <el-form-item label="关联单号：">
        <el-input v-model="keywords_type.goods_order_sn" size="small" @input="getKeywords($event, 3)"></el-input>
      </el-form-item>
      <el-form-item label="来源类型：">
        <el-select v-model="searchForm.service_type" size="small" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="购物增送" :value="1"></el-option>
          <el-option label="分销收入" :value="2"></el-option>
          <el-option label="提现" :value="3"></el-option>
          <el-option label="每个月业绩考核" :value="4"></el-option>
          <el-option label="员工每个月结算" :value="5"></el-option>
          <el-option label="区域分红" :value="6"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结算状态：">
        <el-select v-model="searchForm.type" size="small" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="待入账" :value="1"></el-option>
          <el-option label="已入账" :value="2"></el-option>
          <el-option label="已失效" :value="3"></el-option>
          <el-option label="已扣除" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收益/支出：">
        <el-select v-model="searchForm.status" size="small" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="收益" :value="1"></el-option>
          <el-option label="支出" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产出时间：">
        <el-date-picker
          v-model="searchForm.create_time"
          size="small"
          type="daterange"
          value-format="timestamp"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label=" " label-width="30px">
        <el-button type="primary" size="small" @click="search">搜索</el-button>
        <el-button type="text" size="small" @click="cancelSearch">清空搜索条件</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" :header-cell-style="{ 'background-color': '#F8F9FA' }" row-key="id">
      <template slot="empty">
        <No />
      </template>
      <el-table-column prop="id" label="ID" width="90" align="center"></el-table-column>
      <el-table-column prop="name" label="用户信息" width="200" align="center">
        <template v-slot="{ row }">
          <userInfo :name="row.nickname" :avatar="row.avatar"></userInfo>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
      <el-table-column prop="service_type" label="来源类型" align="center">
        <template v-slot="{ row }">
          {{
            row.service_type == 1
              ? '购物增送'
              : row.service_type == 2
              ? '分销收入'
              : row.service_type == 3
              ? '提现'
              : row.status == 4
              ? '每个月业绩考核'
              : row.status == 5
              ? '员工每个月结算'
              : '区域分红'  
          }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="收益/支出" align="center">
        <template v-slot="{ row }">{{ row.status == 1 ? '收益' : '支出' }}</template>
      </el-table-column>
      <el-table-column prop="type" label="结算状态" align="center">
        <template v-slot="{ row }">{{ row.type == 1 ? '待入账' : row.type == 2 ? '已入账' : row.type == 3 ? '已失效' : '已扣除' }}</template>
      </el-table-column>
      <el-table-column prop="money" label="积分" align="center">
        <template v-slot="{ row }">
          <span :style="{ color: row.status == 1 && row.type != 3 ? '#EA4335' : '#34A853' }">{{ row.status == 1 && row.type != 3 ? '+' + row.money : '-' + row.money }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_info.applysn" label="关联单号" align="center">
        <template v-slot="{ row }">
          <span>{{ row.order_info ? row.order_info.pay_sn : '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="proof" label="打款凭证" align="center">
        <template v-slot="{ row }">
          <el-image v-if="row.proof" style="width: 60px; height: 50px" :src="row.proof" :preview-src-list="[row.proof]"></el-image>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="产生时间" align="center">
        <template v-slot="{ row }">{{ getDateformat(row.create_time) }}</template>
      </el-table-column>
    </el-table>
    <Paging :total="total" :page="searchForm.page" :pageNum="searchForm.rows" @updatePageNum="updateData"></Paging>
  </el-main>
</template>
<script>
import _ from 'lodash';
import { getDateformat } from '@/util/getDate';
import Paging from '@/components/paging';
import userInfo from '@/components/userInfo';
export default {
  components: {
    Paging,
    userInfo,
  },
  data() {
    return {
      keywords_type: {
        goods_order_sn: '',
        nickname: '',
      },
      searchForm: {
        page: 1,
        rows: 10,
        keyworks_type: '',
        keyworks: '',
        status: '',
        create_time: '',
        service_type: '',
        type: '',
      },
      amount_sum: '0.00',
      apply_sum: '0.00',
      cash_sum: '0.00',
      frozen_sum: '0.00',
      list: [],
      total: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    search() {
      this.searchForm.page = 1;
      this.getList();
    },
    cancelSearch() {
      this.searchForm = {
        page: 1,
        rows: 10,
        keyworks_type: '',
        keyworks: '',
        status: '',
        create_time: '',
        service_type: '',
        type: '',
      };
      this.resetKeywordType();
      this.getList();
    },
    getDateformat(val) {
      return getDateformat(val);
    },
    updateData(val, status) {
      if (status == 0) {
        this.searchForm.rows = val;
        this.getList();
      } else {
        this.searchForm.page = val;
        this.getList();
      }
    },
    resetKeywordType(key) {
      for (let i in this.keywords_type) {
        if (i != key) this.keywords_type[i] = '';
      }
    },
    getKeywords(val, type) {
      let searchForm = this.searchForm;
      switch (type) {
        case 1:
          this.resetKeywordType('nickname');
          searchForm.keyworks_type = 'nickname';
          break;
        case 2:
          this.resetKeywordType('member');
          searchForm.keyworks_type = 'member';
          break;
        case 3:
          this.resetKeywordType('goods_order_sn');
          searchForm.keyworks_type = 'goods_order_sn';
          break;
      }
      searchForm.keyworks = val;
    },
    getList() {
      let searchForm = _.cloneDeep(this.searchForm);
      let data = {
        page: searchForm.page,
        rows: searchForm.rows,
      };
      if (searchForm.keyworks) {
        data.keyworks = searchForm.keyworks;
        data.keyworks_type = searchForm.keyworks_type;
      }
      if (searchForm.status) {
        data.status = searchForm.status;
      }
      if (searchForm.service_type) {
        data.service_type = searchForm.service_type;
      }
      if (searchForm.type) {
        data.type = searchForm.type;
      }
      if (searchForm.create_time) {
        for (let i in searchForm.create_time) {
          searchForm.create_time[i] = searchForm.create_time[i] / 1000;
        }
        data.create_time = searchForm.create_time;
      }
      this.$axios.post(this.$api.finance.cashLogList, data).then(res => {
        if (res.code == 0) {
          let list = res.result.list;
          list.map(item => {
            if (item.order_info) {
              item.nickname = item.order_info.extend_user.nickname;
              item.avatar = item.order_info.extend_user.avatar;
              item.mobile = item.order_info.extend_user.mobile;
            }
            if (item.distribution_info) {
              item.nickname = item.distribution_info.nickname;
              item.avatar = item.distribution_info.avatar;
              item.mobile = item.distribution_info.mobile;
            }
          });
          this.list = list;
          this.amount_sum = res.result.amount_sum;
          this.apply_sum = res.result.apply_sum;
          this.cash_sum = res.result.cash_sum;
          this.frozen_sum = res.result.frozen_sum;
          this.total = res.result.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-main {
  background: #fff;
  .total {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    .item {
      width: 372px;
      height: 120px;
      color: #fff;
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding-left: 20px;
      p:nth-child(1) {
        font-size: 36px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p:nth-child(2) {
        font-size: 14px;
      }
      &:nth-child(1) {
        background: url('~@/assets/image/assets_back1.png') no-repeat;
        background-size: 100% 100%;
      }
      &:nth-child(2) {
        background: url('~@/assets/image/assets_back2.png') no-repeat;
        background-size: 100% 100%;
      }
      &:nth-child(3) {
        background: url('~@/assets/image/assets_back3.png') no-repeat;
        background-size: 100% 100%;
      }
      &:nth-child(4) {
        background: url('~@/assets/image/assets_back4.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>